import { CreateUpdateAccountComponent } from '../create-update-account/create-update-account.component';
import { AccountsService } from '../../../../../../views/pages/user-management/system/accounts/accounts.service';
import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { SharedTableComponent } from '../../../../../../trash/shared/components/shared-table/shared-table.component';
import { IAccount, AccountsListApiResponse } from '../../dtos/responses/accounts-list-response';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { BaseComponent } from '../../../../../../trash/shared/components/base/base.component';
import { SahredConstants } from '../../../../../../trash/shared/constants/Values';
import { Subscription, tap, catchError, finalize } from 'rxjs';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { UserManagementPermissions } from '../../../../common/permissions/user-management.permissions';
import { UserContextService } from '../../../../auth-management/authentication/services/user-context.service';
import { IPaginationResponse } from '../../../../../core/data-access/pagination/interfaces/pagination-response.interface';
import { IMenuItemAction } from '../../../../../core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Logger } from '../../../../../core';
import { AssignRevokeScopesComponent } from '../../scopes/components/assign-revoke-scopes/assign-revoke-scopes.component';

@Component({
  selector: 'app-accounts-list',
  standalone: true,
  imports: [
    SkeletonModule,
    CommonModule,
    RouterModule,
    ButtonModule,
    MenuModule,
    SharedTableComponent,
    TranslateModule
  ],
  templateUrl: './accounts-list.component.html',
  styleUrl: './accounts-list.component.scss',
  providers: [DialogService]
})
export class AccountsListComponent extends BaseComponent<any> {
  private subscriptions: Subscription[] = [];

  AccountsRes: AccountsListApiResponse | null = null;
  totalItemCount: number = 0;
  isLoadingItems: boolean = false;
  isLoadingFilter: boolean = false;
  searchTerm: string | null = null;

  items: { headers: string[]; data: IAccount[]; dataKeys: string[] } = {
    headers: ['GENERAL.NAME', 'GENERAL.ACTIONS'],
    data: [] as IAccount[],
    dataKeys: ['englishName', 'action']
  };

  viewItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Accounts.Read);
  addItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Accounts.Create);
  editItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Accounts.Update);
  assignPermissions: boolean = true;
  revokePermissions: boolean = true;

  actionsList: IMenuItemAction[] = [];

  constructor(
    private _AccountsService: AccountsService,
    private toastService: ToastService,
    private dialog: DialogService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.actionsList = [
      ...(this.editItem
        ? [
          {
            label: this.translate.instant('ACTIONS.EDIT'),
            icon: 'pi pi-pen-to-square',
            command: (event: any) => {
              this.openAccountDialog(event, true);
            },
            isView: this.editItem
          }
        ]
        : []),
      ...(this.viewItem
        ? [
          {
            label: this.translate.instant('ACTIONS.VIEW'),
            icon: 'pi pi-eye',
            command: (event: any) => {
              this.openAccountDialog(event, false);
            },
            isView: this.viewItem
          }
        ]
        : []),
      ...(this.assignPermissions
        ? [
          {
            label: `${this.translate.instant('GENERAL.ASSIGN')} ${this.translate.instant('MENUS.SYSTEM_SCOPES')}`,
            icon: 'pi pi-plus',
            type: 'assign',
            command: (event: any) => {
              Logger.debug('event', event);
              this.assignScopes(event);
            },
            isView: this.assignPermissions
          }
        ]
        : []),
      ...(this.revokePermissions
        ? [
          {
            label: `${this.translate.instant('GENERAL.REVOKE')} ${this.translate.instant('MENUS.SYSTEM_SCOPES')}`,
            icon: 'pi pi-replay',
            type: 'revoke',
            command: (event: any) => {
              Logger.debug('event', event);
              this.revokeScopes(event);
            },
            isView: this.revokePermissions
          }
        ]
        : [])
    ];
    this.list(true);
  }

  // Start Get Listing Functions
  async list(filter?: boolean) {
    this.HandelRenderingDataMessage = 'GENERAL.LOADING';
    filter ? (this.isLoadingFilter = true) : (this.isLoadingItems = true);
    let RolesSubscription: Subscription = (await this._AccountsService.getAll(this.request))
      .pipe(
        tap((res: any) => this.processListResponse(res)),
        catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
        finalize(() => this.finalizeListRequest())
      )
      .subscribe();

    this.subscriptions.push(RolesSubscription);
  }
  private processListResponse(response: IPaginationResponse<IAccount>): void {
    if (response) {
      this.AccountsRes = response;
      this.totalItemCount = response.paginationMetadata.totalItemCount as number;
      this.items.data = this.AccountsRes.items as IAccount[];
      if (this.AccountsRes.items.length == 0) {
        this.HandelRenderingDataMessage = 'GENERAL.NO_DATA_FOUND';
      }
      this.cdr.markForCheck();
    } else {
      this.HandelRenderingDataMessage = 'GENERAL.NO_DATA_FOUND';
    }
  }
  private finalizeListRequest(): void {
    this.isLoadingItems = false;
    this.isLoadingFilter = false;
  }
  //  End Get Listing Functions

  openAccountDialog(item?: IAccount | null, visible?: boolean) {
    let headerTitle: string;
    if (visible == false) {
      headerTitle = this.translate.instant('USER_MANAGEMENT.ACCOUNT_DETAILS');
    } else {
      headerTitle = `${item ? this.translate.instant('ACTIONS.EDIT') : this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('USER_MANAGEMENT.ACCOUNT')}`;
    }
    const ref: any = this.dialog.open(CreateUpdateAccountComponent, {
      data: {
        item: item,
        visible: visible
      },
      header: headerTitle,
      styleClass: 'responsive-dialog-width'
    });
    ref?.onClose.subscribe((item?: any) => {
      this.list();
      console.log('clossed');
    });
  }

  private assignScopes(item: any): void {
    const ref = this.dialog.open(AssignRevokeScopesComponent, {
      data: {
        item: item,
        type: 'assign',
        visible: true
      },
      header: `Assign Scopes`,
      styleClass: 'responsive-dialog-width'
    });
    ref?.onClose?.subscribe((item?: any) => {
      if (item) {
        this.resetParams();
        this.list();
      }
    });
  }

  private revokeScopes(item: any): void {
    const ref = this.dialog.open(AssignRevokeScopesComponent, {
      data: {
        item: item,
        type: 'revoke',
        visible: true
      },
      header: `Revoke Scopes`,
      styleClass: 'responsive-dialog-width'
    });
    ref?.onClose?.subscribe((item?: any) => {
      if (item) {
        this.resetParams();
        this.list();
      }
    });
  }

  resetParams(): void {
    this.page = 1;
    this.request.page = SahredConstants.INITIAL_PAGE_INDEX;
    this.request.pageSize = SahredConstants.INITIAL_PAGE_SIZE;
    this.searchTerm = null;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}
